/**
 * @param {{ contentType?: string|null, filename?: string|null }} params
 * @returns {boolean}
 */
export function isPdfDocument({ contentType = "", filename = "" } = {}) {
    const type = String(contentType || "").toLowerCase();
    if (type.includes("pdf")) {
        return true;
    }
    return String(filename || "")
        .toLowerCase()
        .endsWith(".pdf");
}

/**
 * @param {{
 *   document_preview_url?: string|null,
 *   original_filename?: string|null,
 *   content_type?: string|null,
 * }|null|undefined} session
 * @returns {{
 *   documentUrl?: string,
 *   documentFilename?: string,
 *   documentContentType?: string,
 * }}
 */
export function documentPreviewFromSession(session) {
    if (!session?.document_preview_url) {
        return {};
    }
    return {
        documentUrl: session.document_preview_url,
        documentFilename: session.original_filename || "",
        documentContentType: session.content_type || "",
    };
}
